import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useFooterContext } from 'Context/FooterContext';
import useMobileLayout from 'Hooks/useMobileLayout';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2),
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  rootMobile: {},
});

const Footer = ({
  className,
  classes,
}) => {
  const { footerRef } = useFooterContext();
  const { isMobile } = useMobileLayout();

  return (
    <Box
      className={classNames(classes.root, className, {
        [classes.rootMobile]: isMobile,
      })}
      ref={footerRef}
    />
  );
};

Footer.defaultProps = {
  className: '',
};

Footer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Footer);
